import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ============================================================================
// GOOGLE TRANSLATE ↔ REACT SAFETY PATCH
// Google Translate wraps text nodes in <font> tags and moves them around.
// React's reconciler then throws NotFoundError on insertBefore/removeChild
// for nodes it no longer owns. Make these DOM ops no-op instead of crashing.
// (Standard workaround for facebook/react#11538.)
// ============================================================================
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

// ============================================================================
// PREVIEW URL REDIRECT PROTECTION (P0 - CRITICAL)
// Immediately redirects users from blocked preview URLs to official domain
// ============================================================================
const OFFICIAL_DOMAIN = "clarias.in";
const BLOCKED_PREVIEW_URLS = [
  "exam-prep-ai-8.preview.emergentagent.com",
  "clarias-intel.preview.emergentagent.com"
];
// Allowed domains (won't redirect): clarias.in, www.clarias.in, clarias-trainer.preview.emergentagent.com, clarias-trainer.emergent.host, localhost

const currentHost = window.location.hostname;

// Immediately redirect for any blocked preview URL - DO NOT render app
if (BLOCKED_PREVIEW_URLS.includes(currentHost)) {
  // Show a brief message while redirecting
  document.body.innerHTML = `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:system-ui,sans-serif;background:#f8fafc;">
      <div style="text-align:center;padding:2rem;">
        <h1 style="color:#4f46e5;margin-bottom:1rem;">Redirecting to CLARIAS...</h1>
        <p style="color:#64748b;">Please visit our official website</p>
        <p style="color:#4f46e5;font-weight:bold;margin-top:1rem;">https://clarias.in</p>
      </div>
    </div>
  `;
  // Redirect immediately
  window.location.replace(`https://${OFFICIAL_DOMAIN}/`);
  // Stop execution - don't render React app
  throw new Error("Redirecting to official domain");
}
// ============================================================================

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
